<template>
	<div class="okxActivity">
		<img class="posterBg" src="https://f.jinguozi.co/activityImg/2a.jpg"/>
		<!-- <img class="posterBg" src="../../assets/turntable/posterBg3-1.png"/>
		<img class="posterBg" src="../../assets/turntable/posterBg3-2.png"/>
		<img class="posterBg" src="../../assets/turntable/posterBg3-3.png"/> -->
		<button class="button" @click="buttonClick(0)">填写收件地址</button>
		<!-- <button class="button2" @click="buttonClick(1)"></button> -->
		<div class="copyList">
			<button class="copy1" @click="copyClick($event,'https://t.me/jinguozi001')"></button>
			<button class="copy2" @click="copyClick($event,'https://twitter.com/JGZPRO')"></button>
			<button class="copy3" @click="copyClick($event,'https://t.me/jinguozi001')"></button>
			<!-- <button class="copy4" @click="copyClick($event,'https://chat.whatsapp.com/HobclROKu2HGZKTkoewmUN')"></button> -->
		</div>
		<img class="ewm" src="https://f.jinguozi.co/activityImg/1a.png" />
		
		<!-- <div class="alert" v-show="alertShow">
		    <span>{{message}}</span>
		</div> -->
	</div>
</template>

<script>
	import Clipboard from 'clipboard'
	export default {
		data() {
			return {
				loading: true, 
				alertShow:false,
				message:'',
			}
		},
		mounted() {
		},
		methods: {
			showAlert(message) {
			    this.message = message;
			    this.alertShow = true;
			    setTimeout(() => {
			        this.alertShow = false;
			    }, 1500);
			},
			//复制
			copyClick(event,txt){
				let clipboard = new Clipboard(event.target, {
				    text: () => txt
				  })
				console.log(clipboard)
				// this.showAlert('已复制')
				clipboard.on('success', e => {
					this.showAlert('复制成功')
				})
				clipboard.on('error', e => {
					this.showAlert('复制失败')
				})
			},
			
			//
			buttonClick(i){
				if(i == 0){
					window.location.href = 'https://jinshuju.net/f/M78pXE'
				}else{
					window.location.href = 'https://down.jgzpro.com/sign-in/?inviteCode=VFISAR'
				}
				
			}, 
			 
		}
	}
</script>

<style scoped lang="less">
	button{
		border:none;
		background: none;
	}
	html,body{
		background:#1f1f2b;
	}
	.okxActivity{
		width:100%;
		position: relative;
		background:#1f1f2b;
		overflow: hidden;
		padding:0;
		.posterBg{
			margin:0;
			width:100%;
			height:auto;
			display: block;
		}
		.button{
			position: fixed;
			bottom:5vw;
			left:95px;
			align-items: center;
			text-align: center;
			font-size:34px;
			color:#fff;
			width:560px;
			height:88px;
			border-radius:44px;
			background:#FA9A0A;
			z-index:7;
			display: block;
			margin:0;
		}
		.button2{
			position: fixed;
			bottom:19px;
			left:19px;
			width:712px;
			height:150px;
			background: url('../../assets/turntable/posterbutton2.png');
			background-size: 100% 100%;
			z-index:7;
		}
		.ewm{
			position: absolute;
			left:19vw;
			top:394.3vw;
			width:20vw;
			height:20vw;
			z-index: 3;
		}
		.copyList{
			position: absolute;
			z-index:2;
			width:100%;
			height:120vw;
			top:324vw;
			left:0;
			button{
				// background:#FA9A0A;
				position: absolute;
				height:50px;
			}
			.copy1{
				width:44%;
				left:45%;
				top:83vw;
			}
			.copy2{
				width:49%;
				left:45vw;
				top:113vw;
			}
			.copy3{
				width:40%;
				left:54vw;
				top:123vw;
			}
			.copy4{
				width:90%;
				left:5%;
				top:230vw;
			}
		}
	}
	
</style>